/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
import Moment from 'moment'
import Timezone from 'moment-timezone'

export const titleCase = (string) =>
  string
    .split(' ')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ')

export const camelToTitleCase = (str) =>
  str
    // Insert space before upper case letters
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    // Capitalize first letter
    .replace(/^./, (match) => match.toUpperCase())

// converts time and timezone to UTC
export const timeAndTzToUTC = ({ date, timezone }) =>
  date && timezone ? Timezone.tz(date, timezone).utc().format() : Moment(date).utc().format()

// converts time from UTC into timezone for UI
export const parseDateForUI = ({ date, timezone, time }) =>
  date && timezone
    ? time
      ? Timezone.tz(date, timezone).format('MMMM Do, YYYY, LT')
      : Timezone.tz(date, timezone).format('MMMM Do, YYYY')
    : null

// converts time to local timezone
export const parseCreatedForUI = ({ date, time }) =>
  date
    ? time
      ? Moment(date).format('MMMM Do, YYYY, LT')
      : Moment(date).format('MMMM Do, YYYY')
    : null

export const parseDateForPicker = ({ date, timezone }) =>
  date
    ? timezone
      ? Timezone.tz(date, timezone).format('YYYY-MM-DDTHH:mm')
      : Moment(date).utcOffset('+0000').format('YYYY-MM-DDTHH:mm')
    : null

export const parseTagsForUI = (tagName) => titleCase(tagName.split('-').pop().replace(/_/g, ' '))

export const parseTimezoneForUI = (timezoneStr) =>
  timezoneStr.replace(/_/g, ' ').split('/').join('/ ')

export const debounce = (fn, time) => {
  let t = null
  return function () {
    const functionCall = () => fn.apply(this, arguments)
    clearTimeout(t)
    t = setTimeout(functionCall, time)
  }
}

// eslint-disable-next-line
export const generateUUID = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })

export const copyToClipboard = (text, cb) => {
  if (!navigator.clipboard) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      if (cb) cb(successful)
    } catch (err) {
      if (cb) cb(false)
    }

    document.body.removeChild(textArea)
    return
  }

  navigator.clipboard.writeText(text, cb)
}

const commonItemToFields = (item) => {
  // return if query will not exist
  if (!item?.query)
    return {
      text: '',
      id: generateUUID(),
      filter: {},
      types: {},
      filterField: {}
    }

  const filterField = {}
  const key = Object.keys(item.query)[0]
  const field = Object.keys(FILTER_FIELDS).find((_item) => key.startsWith(_item))

  const type = key.replace(field, '')
  const displayType = lookupFilterType(type, item.exclude)

  if (item.filter_class === 'HMGameCompletionFilter') {
    filterField[key] = item.query[key]

    return {
      text: item.query[key],
      id: generateUUID(),
      filter: FILTER_FIELDS['hackersmind_training_data'],
      types: FILTER_TYPES[FILTER_FIELDS['hackersmind_training_data'].type][key],
      filterField
    }
  }

  filterField[key] = item.query[key]

  return {
    text: item.query[key],
    id: generateUUID(),
    filter: FILTER_FIELDS[field] || {},
    types: field ? FILTER_TYPES[FILTER_FIELDS[field].type][displayType] : {},
    filterField
  }
}

const managerItemToFields = (item) => {
  const { filter_class } = item
  const filter =
    filter_class === 'ReportToManagerFilter' ? FILTER_FIELDS.reports_to : FILTER_FIELDS.manager
  return {
    text: item.query,
    id: generateUUID(),
    filter,
    types: FILTER_TYPES.select.exact,
    filterField: item.query
  }
}

export const ObjectToFields = (obj) => {
  const filterObjects = []
  const filterQueryArray = obj[0]

  filterQueryArray.forEach((item) => {
    let fieldData = null
    if (item.filter_class === 'BelowManagerFilter') {
      fieldData = managerItemToFields(item)
    } else {
      fieldData = commonItemToFields(item)
    }
    filterObjects.push(fieldData)
  })

  return filterObjects
}

export const getGraphValues = (
  type = 'percentOverTime',
  min,
  max,
  fontColor = 'rgba(30, 168, 221, .5)'
) => {
  const graphTypes = {
    percentOverTime: {
      responsive: true,
      hoverMode: 'index',
      stacked: false,
      legend: { display: false },
      title: { display: false },
      scales: {
        xAxes: [
          {
            type: 'time',
            distribution: 'linear',
            display: true,
            scaleLabel: {
              display: true
            },
            bounds: 'ticks',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'MMM DD YYYY'
              },
              min,
              max
            },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10,
              source: 'auto',
              major: {
                fontStyle: 'bold',
                fontColor: '#FF0000'
              }
            }
          }
        ],
        yAxes: [
          {
            ticks: {
              min: 0,
              max: 100,
              callback: (value) => `${value}%`
            },
            scaleLabel: { display: false },
            display: true
          }
        ]
      },
      tooltips: {
        callbacks: {
          title: (tooltipItem) => `${tooltipItem[0].yLabel}%`,
          label: (tooltipItem) => Moment(tooltipItem.xLabel).format('MMM DD YYYY')
        },
        position: 'average',
        mode: 'nearest',
        intersect: false,
        yPadding: 10,
        xPadding: 10,
        caretSize: 8,
        backgroundColor: 'rgb(255, 255, 255)',
        titleFontColor: fontColor,
        titleFontSize: 24,
        bodyFontSize: 14,
        bodyFontColor: fontColor,
        borderColor: 'rgba(0,0,0, .5)',
        borderWidth: 1
      }
    }
  }

  return graphTypes[type]
}

/** **************** CLASSES ***************** */

export class RunningAverage {
  constructor() {
    this.denominator = 1
    this.average = null
    this.empty = true
  }

  push = (number) => {
    if (typeof number !== 'number') number = parseInt(number, 10)

    const diff = number - (this.average ? this.average : 0)
    this.average = (this.average ? this.average : 0) + diff / this.denominator
    this.empty = false
    this.denominator++
    return this
  }

  getAverage = () => this.average

  clear = () => {
    this.denominator = 1
    this.average = null
    this.empty = true
  }
}

export const CAMPAIGN_TYPES = {
  // 'Manager Led': 'hackersmind-rollout-manager_led',
  'Peer Scheduling': 'hackersmind-rollout-group_scheduling',
  'Predefined Leads': 'hackersmind-rollout-predefined_leaders'
}

export const INDUSTRY_CODES = {
  AGR: 'Agriculture',
  CON: 'Construction',
  COL: 'Consulting',
  EDU: 'Education',
  FAI: 'Finance and Insurance',
  FSV: 'Food Services',
  GOV: 'Government',
  HEA: 'Healthcare',
  INF: 'Information',
  LIF: 'Life Sciences',
  MAN: 'Manufacturing',
  NPT: 'Nonprofit',
  RET: 'Retail',
  SAT: 'Software and Technology',
  TRA: 'Transportation',
  UTI: 'Utilities',
  OTH: 'Other'
}

export const lookupFilterType = (type, exclude) =>
  ({
    __iexact: `${exclude ? 'not_' : ''}exact`,
    __icontains: `${exclude ? 'not_' : ''}contains`,
    __istartswith: `${exclude ? 'not_' : ''}starts_with`,
    __iendswith: `${exclude ? 'not_' : ''}ends_with`,
    __in: `${exclude ? 'not_' : ''}in`,
    __gt: 'gt',
    __completion_time__gt: 'gt',
    __exclude_completion_time__gt: 'exclude_gt',
    __lt: 'lt',
    __completion_time__lt: 'lt',
    __bool: 'exact',
    __isnull: 'isnull',
    is_incomplete: 'is_incomplete',
    was_not_completed_after: 'was_not_completed_after',
    was_completed_before: 'was_completed_before',
    was_completed_after: 'was_completed_after'
  }[type])

export const FILTER_TYPES = {
  string: {
    exact: {
      display: 'is equal to',
      command: '__iexact',
      key: 'exact'
    },
    not_exact: {
      display: 'is not equal to',
      command: 'not__iexact',
      key: 'exact'
    },
    contains: {
      display: 'contains',
      command: '__icontains',
      key: 'contains'
    },
    not_contains: {
      display: 'does not contain',
      command: 'not__icontains',
      key: 'contains'
    },
    starts_with: {
      display: 'starts with',
      command: '__istartswith',
      key: 'starts_with'
    },
    not_starts_with: {
      display: 'does not start with',
      command: 'not__istartswith',
      key: 'starts_with'
    },
    ends_with: {
      display: 'ends with',
      command: '__iendswith',
      key: 'ends_with'
    },
    not_ends_with: {
      display: 'does not end with',
      command: 'not__iendswith',
      key: 'ends_with'
    },
    in: {
      display: 'is one of',
      command: '__in',
      key: 'in'
    },
    not_in: {
      display: 'is not one of',
      command: 'not__in',
      key: 'in'
    }
  },
  date: {
    gt: {
      display: 'is after',
      command: '__gt',
      key: 'gt'
    },
    lt: {
      display: 'is before',
      command: '__lt',
      key: 'lt'
    }
  },
  completion: {
    gt: {
      display: 'was completed after',
      command: '__completion_time__gt',
      key: 'gt'
    },
    lt: {
      display: 'was completed before',
      command: '__completion_time__lt',
      key: 'lt'
    },
    exclude_gt: {
      display: 'was not completed after',
      command: '__exclude_completion_time__gt',
      key: 'exclude_gt'
    },
    isnull: {
      display: 'is incomplete',
      command: '__isnull',
      key: 'isnull'
    }
  },
  bool: {
    exact: {
      display: 'is equal to',
      command: '',
      key: 'exact'
    }
  },
  select: {
    exact: {
      display: 'is equal to',
      command: '__iexact',
      key: 'exact'
    }
  },
  hackersmind_training_data: {
    was_completed_before: {
      display: 'was completed before',
      command: 'was_completed_before',
      key: 'was_completed_before'
    },
    was_completed_after: {
      display: 'was completed after',
      command: 'was_completed_after',
      key: 'was_completed_after'
    },
    was_not_completed_after: {
      display: 'was not completed after',
      command: 'was_not_completed_after',
      key: 'was_not_completed_after'
    },
    is_incomplete: {
      display: 'is incomplete',
      command: 'is_incomplete',
      key: 'is_incomplete'
    }
  }
}

export const FILTER_FIELDS = {
  first_name: {
    type: 'string',
    display: 'First name',
    key: 'first_name'
  },
  last_name: {
    type: 'string',
    display: 'Last name',
    key: 'last_name'
  },
  email: {
    type: 'string',
    display: 'Email',
    key: 'email'
  },
  title: {
    type: 'string',
    display: 'Title',
    key: 'title'
  },
  department: {
    type: 'string',
    display: 'Department',
    key: 'department'
  },
  location: {
    type: 'string',
    display: 'Location',
    key: 'location'
  },
  preferred_language: {
    type: 'select',
    display: 'Preferred Language',
    key: 'preferred_language'
  },
  start_date: {
    type: 'date',
    display: 'Start date',
    key: 'start_date'
  },
  is_manager: {
    type: 'bool',
    display: 'Manager status',
    key: 'is_manager'
  },
  hackersmind_training_data: {
    type: 'hackersmind_training_data',
    display: "Hacker's Mind training",
    key: 'hackersmind_training_data'
  },
  campaigns__name: {
    type: 'select',
    display: 'Campaign name',
    key: 'campaigns__name'
  },
  is_contractor: {
    type: 'bool',
    display: 'Contractor status',
    key: 'is_contractor'
  },
  manager: {
    type: 'select',
    display: 'Reports to',
    hideOperator: true,
    key: 'manager'
  }
}

export const TIME_ZONES = {
  '(GMT-11:00) Midway': 'Pacific/Midway',
  '(GMT-11:00) Niue': 'Pacific/Niue',
  '(GMT-11:00) Pago Pago': 'Pacific/Pago_Pago',
  '(GMT-11:00) Samoa': 'Pacific/Samoa',
  '(GMT-11:00) Samoa (US)': 'US/Samoa',
  '(GMT-10:00) Hawaii Time': 'Pacific/Honolulu',
  '(GMT-10:00) Johnston': 'Pacific/Johnston',
  '(GMT-10:00) Rarotonga': 'Pacific/Rarotonga',
  '(GMT-10:00) Tahiti': 'Pacific/Tahiti',
  '(GMT-10:00) US - Aleutian': 'US/Aleutian',
  '(GMT-09:30) Marquesas': 'Pacific/Marquesas',
  '(GMT-09:00) Alaska Time': 'America/Anchorage',
  '(GMT-09:00) Gambier': 'Pacific/Gambier',
  '(GMT-09:00) US - Alaska': 'US/Alaska',
  '(GMT-08:00) Pacific Time': 'America/Los_Angeles',
  '(GMT-08:00) Pacific Time - Canada': 'Canada/Pacific',
  '(GMT-08:00) Pacific Time - Yukon': 'Canada/Yukon',
  '(GMT-08:00) Pacific Time - Tijuana': 'America/Tijuana',
  '(GMT-08:00) Pacific Time - Vancouver': 'America/Vancouver',
  '(GMT-08:00) Pacific Time - Whitehorse': 'America/Whitehorse',
  '(GMT-08:00) Pitcairn': 'Pacific/Pitcairn',
  '(GMT-07:00) US - Pacific': 'US/Pacific',
  '(GMT-07:00) Mexico - Baja Norte': 'Mexico/BajaNorte',
  '(GMT-07:00) Mountain Time': 'America/Denver',
  '(GMT-07:00) Mountain Time - Arizona': 'America/Phoenix',
  '(GMT-07:00) Mountain Time - Canada': 'Canada/Mountain',
  '(GMT-07:00) Mountain Time - Chihuahua, Mazatlan': 'America/Mazatlan',
  '(GMT-07:00) Mountain Time - Dawson Creek': 'America/Dawson_Creek',
  '(GMT-07:00) Mountain Time - Edmonton': 'America/Edmonton',
  '(GMT-07:00) Mountain Time - Hermosillo': 'America/Hermosillo',
  '(GMT-07:00) Mountain Time - Ojinaga': 'America/Ojinaga',
  '(GMT-07:00) Mountain Time - Idaho': 'America/Boise',
  '(GMT-07:00) Mountain Time - Yellowknife': 'America/Yellowknife',
  '(GMT-07:00) US - Arizona': 'US/Arizona',
  '(GMT-07:00) US - Mountain': 'US/Mountain',
  '(GMT-06:00) Belize': 'America/Belize',
  '(GMT-06:00) Central Time': 'America/Chicago',
  '(GMT-06:00) Central Time - Canada': 'Canada/Central',
  '(GMT-06:00) Central Time - Mexico City': 'America/Mexico_City',
  '(GMT-06:00) Central Time - Regina': 'America/Regina',
  '(GMT-06:00) Central Time - Tegucigalpa': 'America/Tegucigalpa',
  '(GMT-06:00) Central Time - Winnipeg': 'America/Winnipeg',
  '(GMT-06:00) Costa Rica': 'America/Costa_Rica',
  '(GMT-06:00) El Salvador': 'America/El_Salvador',
  '(GMT-06:00) Galapagos': 'Pacific/Galapagos',
  '(GMT-06:00) Guatemala': 'America/Guatemala',
  '(GMT-06:00) Managua': 'America/Managua',
  '(GMT-06:00) Mexico - Baja Sur': 'Mexico/BajaSur',
  '(GMT-06:00) Mexico - General': 'Mexico/General',
  '(GMT-06:00) US - Central': 'US/Central',
  '(GMT-05:00) America Cancun': 'America/Cancun',
  '(GMT-05:00) America Cayman': 'America/Cayman',
  '(GMT-05:00) Bogota': 'America/Bogota',
  '(GMT-05:00) Easter Island': 'Pacific/Easter',
  '(GMT-05:00) Eastern Time': 'America/New_York',
  '(GMT-05:00) Eastern Time - Canada': 'Canada/Eastern',
  '(GMT-05:00) Eastern Time - Detroit': 'America/Detroit',
  '(GMT-05:00) Eastern Time - Indianapolis': 'America/Indianapolis',
  '(GMT-05:00) Eastern Time - Iqaluit': 'America/Iqaluit',
  '(GMT-05:00) Eastern Time - Montreal': 'America/Montreal',
  '(GMT-05:00) Eastern Time - Thunder Bay': 'America/Thunder_Bay',
  '(GMT-05:00) Eastern Time - Toronto': 'America/Toronto',
  '(GMT-05:00) US - Eastern': 'US/Eastern',
  '(GMT-05:00) Guayaquil': 'America/Guayaquil',
  '(GMT-05:00) Havana': 'America/Havana',
  '(GMT-05:00) Jamaica': 'America/Jamaica',
  '(GMT-05:00) Jamaica (alternate)': 'Jamaica',
  '(GMT-05:00) Lima': 'America/Lima',
  '(GMT-05:00) Nassau': 'America/Nassau',
  '(GMT-05:00) Panama': 'America/Panama',
  '(GMT-05:00) Port-au-Prince': 'America/Port-au-Prince',
  '(GMT-05:00) Rio Branco': 'America/Rio_Branco',
  '(GMT-05:00) US - East Indiana': 'US/East-Indiana',
  '(GMT-04:00) Atlantic Time - Canada': 'Canada/Atlantic',
  '(GMT-04:00) Atlantic Time - Halifax': 'America/Halifax',
  '(GMT-04:00) Barbados': 'America/Barbados',
  '(GMT-04:00) Bermuda': 'Atlantic/Bermuda',
  '(GMT-04:00) Boa Vista': 'America/Boa_Vista',
  '(GMT-04:00) Brazil - West': 'Brazil/West',
  '(GMT-04:00) Caracas': 'America/Caracas',
  '(GMT-04:00) Curacao': 'America/Curacao',
  '(GMT-04:00) Grand Turk': 'America/Grand_Turk',
  '(GMT-04:00) Guyana': 'America/Guyana',
  '(GMT-04:00) La Paz': 'America/La_Paz',
  '(GMT-04:00) Manaus': 'America/Manaus',
  '(GMT-04:00) Martinique': 'America/Martinique',
  '(GMT-04:00) Muscat': 'Asia/Muscat',
  '(GMT-04:00) Port of Spain': 'America/Port_of_Spain',
  '(GMT-04:00) Porto Velho': 'America/Porto_Velho',
  '(GMT-04:00) Puerto Rico': 'America/Puerto_Rico',
  '(GMT-04:00) Santo Domingo': 'America/Santo_Domingo',
  '(GMT-04:00) Thule': 'America/Thule',
  '(GMT-03:30) Newfoundland Time - St. Johns': 'America/St_Johns',
  '(GMT-03:30) Newfoundland Time - Canada': 'Canada/Newfoundland',
  '(GMT-03:00) Araguaina': 'America/Araguaina',
  '(GMT-03:00) Asuncion': 'America/Asuncion',
  '(GMT-03:00) Belem': 'America/Belem',
  '(GMT-03:00) Buenos Aires': 'America/Argentina/Buenos_Aires',
  '(GMT-03:00) Buenos Aires (alternate)': 'America/Buenos_Aires',
  '(GMT-02:00) Brazil - East': 'Brazil/East',
  '(GMT-03:00) Campo Grande': 'America/Campo_Grande',
  '(GMT-03:00) Chile': 'Chile/Continental',
  '(GMT-03:00) Cayenne': 'America/Cayenne',
  '(GMT-03:00) Cuiaba': 'America/Cuiaba',
  '(GMT-03:00) Fortaleza': 'America/Fortaleza',
  '(GMT-03:00) Godthab': 'America/Godthab',
  '(GMT-03:00) Maceio': 'America/Maceio',
  '(GMT-03:00) Miquelon': 'America/Miquelon',
  '(GMT-03:00) Montevideo': 'America/Montevideo',
  '(GMT-03:00) Palmer': 'Antarctica/Palmer',
  '(GMT-03:00) Paramaribo': 'America/Paramaribo',
  '(GMT-03:00) Punta Arenas': 'America/Punta_Arenas',
  '(GMT-03:00) Recife': 'America/Recife',
  '(GMT-03:00) Rothera': 'Antarctica/Rothera',
  '(GMT-03:00) Salvador': 'America/Bahia',
  '(GMT-03:00) Santiago': 'America/Santiago',
  '(GMT-03:00) Stanley': 'Atlantic/Stanley',
  '(GMT-02:00) Noronha': 'America/Noronha',
  '(GMT-02:00) Sao Paulo': 'America/Sao_Paulo',
  '(GMT-02:00) South Georgia': 'Atlantic/South_Georgia',
  '(GMT-01:00) Azores': 'Atlantic/Azores',
  '(GMT-01:00) Cape Verde': 'Atlantic/Cape_Verde',
  '(GMT-01:00) Scoresbysund': 'America/Scoresbysund',
  '(GMT+00:00) Abidjan': 'Africa/Abidjan',
  '(GMT+00:00) Accra': 'Africa/Accra',
  '(GMT+00:00) Bissau': 'Africa/Bissau',
  '(GMT+00:00) Canary Islands': 'Atlantic/Canary',
  '(GMT+00:00) Casablanca': 'Africa/Casablanca',
  '(GMT+00:00) Danmarkshavn': 'America/Danmarkshavn',
  '(GMT+00:00) Dublin': 'Europe/Dublin',
  '(GMT+00:00) El Aaiun': 'Africa/El_Aaiun',
  '(GMT+00:00) Faeroe': 'Atlantic/Faroe',
  '(GMT+00:00) GMT (no daylight saving)': 'Etc/GMT',
  '(GMT+00:00) GMT (alternate)': 'Greenwich',
  '(GMT+00:00) Lisbon': 'Europe/Lisbon',
  '(GMT+00:00) London': 'Europe/London',
  '(GMT+00:00) Great Britain': 'GB',
  '(GMT+00:00) Guernsey': 'Europe/Guernsey',
  '(GMT+00:00) Monrovia': 'Africa/Monrovia',
  '(GMT+00:00) Reykjavik': 'Atlantic/Reykjavik',
  '(GMT+00:00) Iceland': 'Iceland',
  UTC: 'UTC',
  '(GMT+01:00) Algiers': 'Africa/Algiers',
  '(GMT+01:00) Amsterdam': 'Europe/Amsterdam',
  '(GMT+01:00) Andorra': 'Europe/Andorra',
  '(GMT+01:00) Belfast': 'Europe/Belfast',
  '(GMT+01:00) Berlin': 'Europe/Berlin',
  '(GMT+01:00) Brussels': 'Europe/Brussels',
  '(GMT+01:00) Budapest': 'Europe/Budapest',
  '(GMT+01:00) Central European Time - Belgrade': 'Europe/Belgrade',
  '(GMT+01:00) Central European Time - Prague': 'Europe/Prague',
  '(GMT+01:00) Ceuta': 'Africa/Ceuta',
  '(GMT+01:00) Copenhagen': 'Europe/Copenhagen',
  '(GMT+01:00) Gibraltar': 'Europe/Gibraltar',
  '(GMT+01:00) Isle_of_Man': 'Europe/Isle_of_Man',
  '(GMT+01:00) Jersey': 'Europe/Jersey',
  '(GMT+01:00) Lagos': 'Africa/Lagos',
  '(GMT+01:00) Luxembourg': 'Europe/Luxembourg',
  '(GMT+01:00) Madrid': 'Europe/Madrid',
  '(GMT+01:00) Malta': 'Europe/Malta',
  '(GMT+01:00) Monaco': 'Europe/Monaco',
  '(GMT+01:00) Ndjamena': 'Africa/Ndjamena',
  '(GMT+01:00) Oslo': 'Europe/Oslo',
  '(GMT+01:00) Paris': 'Europe/Paris',
  '(GMT+01:00) Portugal': 'Portugal',
  '(GMT+01:00) Rome': 'Europe/Rome',
  '(GMT+01:00) Stockholm': 'Europe/Stockholm',
  '(GMT+01:00) Tirane': 'Europe/Tirane',
  '(GMT+01:00) Tunis': 'Africa/Tunis',
  '(GMT+01:00) Vienna': 'Europe/Vienna',
  '(GMT+01:00) Warsaw': 'Europe/Warsaw',
  '(GMT+01:00) Zurich': 'Europe/Zurich',
  '(GMT+02:00) Amman': 'Asia/Amman',
  '(GMT+02:00) Athens': 'Europe/Athens',
  '(GMT+02:00) Beirut': 'Asia/Beirut',
  '(GMT+02:00) Bratislava': 'Europe/Bratislava',
  '(GMT+02:00) Bucharest': 'Europe/Bucharest',
  '(GMT+02:00) Cairo': 'Africa/Cairo',
  '(GMT+02:00) Chisinau': 'Europe/Chisinau',
  '(GMT+02:00) Damascus': 'Asia/Damascus',
  '(GMT+02:00) Gaza': 'Asia/Gaza',
  '(GMT+02:00) Gaborone': 'Africa/Gaborone',
  '(GMT+02:00) Harare': 'Africa/Harare',
  '(GMT+02:00) Helsinki': 'Europe/Helsinki',
  '(GMT+02:00) Jerusalem': 'Asia/Jerusalem',
  '(GMT+02:00) Johannesburg': 'Africa/Johannesburg',
  '(GMT+02:00) Khartoum': 'Africa/Khartoum',
  '(GMT+02:00) Kiev': 'Europe/Kiev',
  '(GMT+02:00) Ljubljana': 'Europe/Ljubljana',
  '(GMT+02:00) Maputo': 'Africa/Maputo',
  '(GMT+02:00) Moscow-01 - Kaliningrad': 'Europe/Kaliningrad',
  '(GMT+02:00) Nicosia': 'Asia/Nicosia',
  '(GMT+02:00) Poland': 'Poland',
  '(GMT+02:00) Riga': 'Europe/Riga',
  '(GMT+02:00) Sofia': 'Europe/Sofia',
  '(GMT+02:00) Tallinn': 'Europe/Tallinn',
  '(GMT+02:00) Tripoli': 'Africa/Tripoli',
  '(GMT+02:00) Vilnius': 'Europe/Vilnius',
  '(GMT+02:00) Windhoek': 'Africa/Windhoek',
  '(GMT+02:00) Zagreb': 'Europe/Zagreb',
  '(GMT+03:00) Antananarivo': 'Indian/Antananarivo',
  '(GMT+03:00) Baghdad': 'Asia/Baghdad',
  '(GMT+03:00) Comoro': 'Indian/Comoro',
  '(GMT+03:00) Istanbul (alternate)': 'Asia/Istanbul',
  '(GMT+03:00) Istanbul': 'Europe/Istanbul',
  '(GMT+03:00) Mayotte': 'Indian/Mayotte',
  '(GMT+03:00) Turkey': 'Turkey',
  '(GMT+03:00) Kirov': 'Europe/Kirov',
  '(GMT+03:00) Minsk': 'Europe/Minsk',
  '(GMT+03:00) Moscow+00 - Moscow': 'Europe/Moscow',
  '(GMT+03:00) Nairobi': 'Africa/Nairobi',
  '(GMT+03:00) Qatar': 'Asia/Qatar',
  '(GMT+03:00) Riyadh': 'Asia/Riyadh',
  '(GMT+03:00) Syowa': 'Antarctica/Syowa',
  '(GMT+03:00) Tel Aviv': 'Asia/Tel_Aviv',
  '(GMT+03:00) Volgograd': 'Europe/Volgograd',
  '(GMT+03:00) Israel': 'Asia/Israel',
  '(GMT+03:30) Tehran': 'Asia/Tehran',
  '(GMT+04:00) Baku': 'Asia/Baku',
  '(GMT+04:00) Dubai': 'Asia/Dubai',
  '(GMT+04:00) Mahe': 'Indian/Mahe',
  '(GMT+04:00) Mauritius': 'Indian/Mauritius',
  '(GMT+04:00) Moscow+01 - Samara': 'Europe/Samara',
  '(GMT+04:00) Reunion': 'Indian/Reunion',
  '(GMT+04:00) Tbilisi': 'Asia/Tbilisi',
  '(GMT+04:00) Yerevan': 'Asia/Yerevan',
  '(GMT+04:30) Kabul': 'Asia/Kabul',
  '(GMT+05:00) Aqtau': 'Asia/Aqtau',
  '(GMT+05:00) Aqtobe': 'Asia/Aqtobe',
  '(GMT+05:00) Ashgabat': 'Asia/Ashgabat',
  '(GMT+05:00) Dushanbe': 'Asia/Dushanbe',
  '(GMT+05:00) Karachi': 'Asia/Karachi',
  '(GMT+05:00) Kerguelen': 'Indian/Kerguelen',
  '(GMT+05:00) Maldives': 'Indian/Maldives',
  '(GMT+05:00) Mawson': 'Antarctica/Mawson',
  '(GMT+05:00) Moscow+02 - Yekaterinburg': 'Asia/Yekaterinburg',
  '(GMT+05:00) Tashkent': 'Asia/Tashkent',
  '(GMT+05:30) Colombo': 'Asia/Colombo',
  '(GMT+05:30) India Standard Time': 'Asia/Kolkata',
  '(GMT+05:45) Kathmandu': 'Asia/Kathmandu',
  '(GMT+06:00) Almaty': 'Asia/Almaty',
  '(GMT+06:00) Bishkek': 'Asia/Bishkek',
  '(GMT+06:00) Chagos': 'Indian/Chagos',
  '(GMT+06:00) Dhaka': 'Asia/Dhaka',
  '(GMT+06:00) Moscow+03 - Omsk': 'Asia/Omsk',
  '(GMT+06:00) Thimphu': 'Asia/Thimphu',
  '(GMT+06:00) Thimbu': 'Asia/Thimbu',
  '(GMT+06:00) Vostok': 'Antarctica/Vostok',
  '(GMT+06:30) Cocos': 'Indian/Cocos',
  '(GMT+06:30) Rangoon': 'Asia/Yangon',
  '(GMT+07:00) Bangkok': 'Asia/Bangkok',
  '(GMT+07:00) Christmas': 'Indian/Christmas',
  '(GMT+07:00) Davis': 'Antarctica/Davis',
  '(GMT+07:00) Hanoi': 'Asia/Saigon',
  '(GMT+07:00) Hovd': 'Asia/Hovd',
  '(GMT+07:00) Jakarta': 'Asia/Jakarta',
  '(GMT+07:00) Moscow+04 - Krasnoyarsk': 'Asia/Krasnoyarsk',
  '(GMT+07:00) Kuwait': 'Asia/Kuwait',
  '(GMT+07:00) Phnom Penh': 'Asia/Phnom_Penh',
  '(GMT+07:00) Pontianak': 'Asia/Pontianak',
  '(GMT+08:00) Brunei': 'Asia/Brunei',
  '(GMT+08:00) China Time - Beijing': 'Asia/Shanghai',
  '(GMT+08:00) Choibalsan': 'Asia/Choibalsan',
  '(GMT+08:00) Hong Kong': 'Asia/Hong_Kong',
  '(GMT+08:00) Hongkong': 'Hongkong',
  '(GMT+08:00) Kuching': 'Asia/Kuala_Lumpur',
  '(GMT+08:00) Macau': 'Asia/Macau',
  '(GMT+08:00) Makassar': 'Asia/Makassar',
  '(GMT+08:00) Manila': 'Asia/Manila',
  '(GMT+08:00) Moscow+05 - Irkutsk': 'Asia/Irkutsk',
  '(GMT+08:00) Singapore': 'Asia/Singapore',
  '(GMT+08:00) Singapore (alternate)': 'Singapore',
  '(GMT+08:00) Taipei': 'Asia/Taipei',
  '(GMT+08:00) Ulaanbaatar': 'Asia/Ulaanbaatar',
  '(GMT+08:00) Western Time - Perth': 'Australia/Perth',
  '(GMT+08:00) Western Time': 'Australia/West',
  '(GMT+08:30) Pyongyang': 'Asia/Pyongyang',
  '(GMT+08:45) Eucla': 'Australia/Eucla',
  '(GMT+08:45) Queensland': 'Australia/Queensland',
  '(GMT+09:00) Dili': 'Asia/Dili',
  '(GMT+09:00) Jayapura': 'Asia/Jayapura',
  '(GMT+09:00) Moscow+06 - Yakutsk': 'Asia/Yakutsk',
  '(GMT+09:00) Palau': 'Pacific/Palau',
  '(GMT+09:00) Pyongyang': 'Asia/Pyongyang',
  '(GMT+09:00) Seoul': 'Asia/Seoul',
  '(GMT+09:00) Tokyo': 'Asia/Tokyo',
  '(GMT+09:00) Japan': 'Japan',
  '(GMT+09:30) Central Time - Darwin': 'Australia/Darwin',
  '(GMT+09:30) Central Time - North Australia': 'Australia/North',
  '(GMT+09:30) Central Time - NSW': 'Australia/NSW',
  '(GMT+09:30) Central Time - South Australia': 'Australia/South',
  '(GMT+09:30) Central Time - Yancowinna': 'Australia/Yancowinna',
  "(GMT+10:00) Dumont D'Urville": 'Antarctica/DumontDUrville',
  '(GMT+10:00) Eastern Time - ACT': 'Australia/ACT',
  '(GMT+10:00) Eastern Time - Brisbane': 'Australia/Brisbane',
  '(GMT+10:00) Eastern Time - Canberra': 'Australia/Canberra',
  '(GMT+10:00) Eastern Time - Currie': 'Australia/Currie',
  '(GMT+10:00) Eastern Time - Tasmania': 'Australia/Tasmania',
  '(GMT+10:00) Eastern Time - Victoria': 'Australia/Victoria',
  '(GMT+10:00) Guam': 'Pacific/Guam',
  '(GMT+10:00) Moscow+07 - Vladivostok': 'Asia/Vladivostok',
  '(GMT+10:00) Port Moresby': 'Pacific/Port_Moresby',
  '(GMT+10:00) Saipan': 'Pacific/Saipan',
  '(GMT+10:00) Chuuk': 'Pacific/Chuuk',
  '(GMT+10:00) Truk': 'Pacific/Truk',
  '(GMT+10:00) Yap': 'Pacific/Yap',
  '(GMT+10:30) Central Time - Adelaide': 'Australia/Adelaide',
  '(GMT+10:30) Central Time - LHI': 'Australia/LHI',
  '(GMT+11:00) Bougainville': 'Pacific/Bougainville',
  '(GMT+11:00) Casey': 'Antarctica/Casey',
  '(GMT+11:00) Eastern Time - Hobart': 'Australia/Hobart',
  '(GMT+11:00) Eastern Time - Melbourne': 'Australia/Melbourne',
  '(GMT+11:00) Eastern Time - Melbourne, Sydney': 'Australia/Sydney',
  '(GMT+11:00) Efate': 'Pacific/Efate',
  '(GMT+11:00) Guadalcanal': 'Pacific/Guadalcanal',
  '(GMT+11:00) Kosrae': 'Pacific/Kosrae',
  '(GMT+11:00) Moscow+08 - Magadan': 'Asia/Magadan',
  '(GMT+11:00) Norfolk': 'Pacific/Norfolk',
  '(GMT+11:00) Noumea': 'Pacific/Noumea',
  '(GMT+11:00) Pohnpei': 'Pacific/Pohnpei',
  '(GMT+11:00) Ponape': 'Pacific/Ponape',
  '(GMT+11:00) Sakhalin': 'Asia/Sakhalin',
  '(GMT+12:00) Funafuti': 'Pacific/Funafuti',
  '(GMT+12:00) Kwajalein': 'Pacific/Kwajalein',
  '(GMT+12:00) Majuro': 'Pacific/Majuro',
  '(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy': 'Asia/Kamchatka',
  '(GMT+12:00) Nauru': 'Pacific/Nauru',
  '(GMT+12:00) Tarawa': 'Pacific/Tarawa',
  '(GMT+12:00) Wake': 'Pacific/Wake',
  '(GMT+12:00) Wallis': 'Pacific/Wallis',
  '(GMT+12:45) Chatham': 'Pacific/Chatham',
  '(GMT+13:00) Auckland': 'Pacific/Auckland',
  '(GMT+13:00) Enderbury': 'Pacific/Enderbury',
  '(GMT+13:00) Fakaofo': 'Pacific/Fakaofo',
  '(GMT+13:00) Fiji': 'Pacific/Fiji',
  '(GMT+13:00) Tongatapu': 'Pacific/Tongatapu',
  '(GMT+14:00) Apia': 'Pacific/Apia',
  '(GMT+14:00) Kiritimati': 'Pacific/Kiritimati'
}

export const TOKEN_EXPIRATIONS = {
  /* cognito refresh token expiration */ '01:00:00': '1h',
  '02:00:00': '2h',
  '04:00:00': '4h',
  '08:00:00': '8h',
  '12:00:00': '12h',
  '1 00:00:00': '1d'
}

export const LANGUAGES = {
  'en-US': 'English',
  'fr-FR': 'French',
  'de-DE': 'German',
  'es-ES': 'Spanish'
}
